export enum ServiceVehicleFormTabs {
  BasicInformation = 'basic-information',
  VehicleData = 'vehicle-data',
  Features = 'features',
  ServiceIntervals = 'service-intervals',
}
